// Phone detection for the alarm warning (architecture sprint-14 §8.2, Decision 16). Pure core plus a reader of the
// current browser. A coarse primary pointer AND a phone/tablet user agent (or an iPadOS "Macintosh" with touch).

export interface DeviceSignals {
  coarsePointer: boolean;
  userAgent: string;
  maxTouchPoints: number;
}

const MOBILE_UA = /Mobi|Android|iPhone|iPad/i;
const MAC_UA = /Macintosh/;

export function isPhoneDevice(s: DeviceSignals): boolean {
  return s.coarsePointer && (MOBILE_UA.test(s.userAgent) || (MAC_UA.test(s.userAgent) && s.maxTouchPoints > 1));
}

export function currentDeviceSignals(): DeviceSignals {
  let coarsePointer = false;
  try {
    coarsePointer = typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia('(pointer: coarse)').matches;
  } catch {
    coarsePointer = false;
  }
  const nav = typeof navigator !== 'undefined' ? navigator : null;
  return { coarsePointer, userAgent: nav?.userAgent ?? '', maxTouchPoints: nav?.maxTouchPoints ?? 0 };
}

export function currentDevice(): 'laptop' | 'phone' {
  return isPhoneDevice(currentDeviceSignals()) ? 'phone' : 'laptop';
}
